import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

//it creates new action action types and they are added to extraReducers
export const fetchAllProductsData = createAsyncThunk(
  "product/fetchProductItems",
  async () => {
    try {
      const response = await fetch("https://fakestoreapi.com/products");
      return response.json();
    } catch (err) {
      throw err;
    }
  }
);

const slice = createSlice({
  name: "product",
  initialState: {
    loading: false,
    list: [],
    error: "",
  },
  reducers: {
    // loadProducts(state, action) {
    //   state.loading = false;
    //   (state.list = action.payload), (state.error = "");
    // },
    // loadingState(state) {
    //   state.loading = true;
    // },
    // loadingError(state, action) {
    //   (state.loading = false),
    //     (state.error = action.payload || "Something went wrong.");
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProductsData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllProductsData.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
        state.error = "";
      })
      .addCase(fetchAllProductsData.rejected, (state, action) => {
        (state.loading = false),
          (state.error = action.payload || "Something went wrong.");
      });
  },
});

export const getAllProducts = (state) => state.products.list;
export const getProductLoadingState = (state) => state.products.loading;
export const getProductErrorState = (state) => state.products.error;

// export const { loadProducts, loadingState, loadingError } = slice.actions;

//thunk action creator
// export const fetchAllProductsData = () => (dispatch) => {
//   dispatch(loadingState());
//   fetch("https://fakestoreapi.com/products")
//     .then((res) => {
//       if (!res.ok) {
//         throw new Error("Failed to fetch products. Please try again later.");
//       }
//       return res.json();
//     })
//     .then((data) => {
//       dispatch(loadProducts(data));
//     })
//     .catch((err) => {
//       dispatch(loadingError(err.message));
//     });
// };

export default slice.reducer;
